import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEOHead - Composant réutilisable pour les meta tags SEO par page.
 * Utilise react-helmet-async pour injecter dynamiquement les balises <head>.
 * 
 * Usage:
 *   <SEOHead 
 *     title="Ma Page" 
 *     description="Description de la page" 
 *     path="/ma-page" 
 *   />
 */
const SEOHead = ({ 
  title, 
  description, 
  path = '/', 
  noindex = false,
  ogType = 'website',
  ogImage = '/icons/icon-512x512.png'
}) => {
  const baseUrl = 'https://www.nodemented.com';
  const fullUrl = `${baseUrl}${path}`;
  const siteName = 'NodeMented';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Création Documentation, Tests et Spécifications | Outil IA pour Développeurs`;
  const defaultDescription = 'NodeMented - Plateforme intelligente pour la création de documentation technique, gestion de tests automatisés et rédaction de spécifications logicielles avec IA.';
  const desc = description || defaultDescription;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`${baseUrl}${ogImage}`} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={`${baseUrl}${ogImage}`} />
    </Helmet>
  );
};

export default SEOHead;
